import pro1 from "../assets/project1.png";
import pro2 from "../assets/project2.png";
import pro3 from "../assets/project3.png";

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Front End Development",
        text: "We implement visual elements that users see and interact within a web application. We are proficient in front end languages such as React, HTML, CSS, Bootstrap and JavaScript that support the appearance and performance of websites, applications and products to improve UI/UX.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE"
    },
    {
        imgsrc: pro2,
        title: "Back End Development",
        text: "We develop all server-side logic, definition and maintenance of the central database, and ensuring high performance and responsiveness to requests from the front-end. We are proficent in Backend languages and Frameworks such as Python, C#, Django, REST, SQL and JavaScript. ",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE"
    },
    {
        imgsrc: pro3,
        title: "WordPress Design",
        text: "We design and implement websites for companies using the WordPress creation tool. We are responsible for both front-end and back-end development, including the implementation of themes and plugins. We also build ecommerce website with conversions in mind to help you sell more online.",
        view: "https://www.youtube.com/watch?v=P8YuWEkTeuE"
    },
]


export default ProjectCardData;